import { Flex, Form, message } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Button from 'components/Button';
import { useTranslation } from 'react-i18next';
import useAddNotesMutation, {
  AddNotesPayload,
} from 'screens/task-management/hooks/mutations/useAddNotesMutation';

interface TaskFailureNotesFormProps {
  taskId: string;
  onAddFailureNotesSuccess?: () => void;
  onCancel?: () => void;
}

type TaskFailureNotesFormValues = {
  notes: string | null;
};

const TaskFailureNotesForm = ({
  taskId,
  onAddFailureNotesSuccess,
  onCancel,
}: TaskFailureNotesFormProps) => {
  const { t } = useTranslation();
  const [form] = Form.useForm<TaskFailureNotesFormValues>();

  const addFailureNotesMutation = useAddNotesMutation();

  const handleFormSubmit = (values: TaskFailureNotesFormValues) => {
    const payload: AddNotesPayload = {
      taskAssignmentId: taskId,
      type: 'FAILURE',
      notes: values?.notes || '',
    };

    addFailureNotesMutation.mutateAsync(payload, {
      onSuccess: async () => {
        message.success(t('taskManagement.labels.addFailureNoteSuccess'));
        onAddFailureNotesSuccess?.();
      },
      onError: (error) => {
        message.error(error?.message || t('common.somethingWrong'));
      },
    });
  };

  return (
    <Form
      className="w-100 task-rescheduler-form"
      form={form}
      layout="vertical"
      initialValues={{
        notes: null,
      }}
      onFinish={handleFormSubmit}
    >
      <Form.Item
        className="w-100"
        name="notes"
        label={t('common.notes')}
        rules={[
          {
            required: true,
            message: t('common.fieldRequired', {
              value: t('common.notes'),
            }),
          },
          { max: 250, message: t('common.maxCharacters', { value: 250 }) },
        ]}
      >
        <TextArea showCount rows={4} className="w-full mb-1" maxLength={250} />
      </Form.Item>

      <Flex align="center" gap={8} className="mt-2">
        <Button type="default" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
        <Button
          trackerLabel={`Task Failure Notes Form Submit - Task ID: ${taskId}`}
          type="primary"
          htmlType="submit"
          loading={addFailureNotesMutation.isPending}
        >
          {t('common.submit')}
        </Button>
      </Flex>
    </Form>
  );
};

export default TaskFailureNotesForm;
